import { render, staticRenderFns } from "./WellBeingCard.vue?vue&type=template&id=85111d1a&"
import script from "./WellBeingCard.vue?vue&type=script&lang=js&"
export * from "./WellBeingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports